"use client";

import Link from "next/link";
import type { FaqCategory } from "./faqTypes";
import { FaqSection } from "./FaqSection";
import { FaqBrandMark } from "./FaqBrandMark";

export interface FaqCategoryViewProps {
  category: FaqCategory;
  backToFaqLabel: string;
}

/**
 * FAQ category page layout: back link, category header, and anchored sections.
 */
export function FaqCategoryView({ category, backToFaqLabel }: FaqCategoryViewProps) {
  return (
    <div className="gruv-faq">
      <div className="gruv-faq__panel">
        <header className="gruv-faq__header">
          <FaqBrandMark />
          <h1 className="gruv-faq__title">{category.label}</h1>
          <p className="gruv-faq__subtitle">{category.description}</p>
        </header>

        <Link href="/faq" className="gruv-faq__back">
          <span className="gruv-faq__back-arrow" aria-hidden>
            ←
          </span>
          {backToFaqLabel}
        </Link>

        <div className="gruv-faq__sections" data-testid="faq-sections">
          {category.sections.map((section) => (
            <FaqSection key={section.id} section={section} itemIdPrefix={category.id} />
          ))}
        </div>
      </div>
    </div>
  );
}
